import { useEffect, useState } from 'react';
import { CoreBox } from '@youscience/core';

interface CircularProgressProps {
  filling: number;
  size?: number;
  color?: string;
  label?: string;
}

const STROKE_WIDTH = 4;
const STYLES = {
  transition: 'all 0.5s',
};

export const ProgressCircle = ({ size = 140, filling, color = '#009299', label = '' }: CircularProgressProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress(filling);
  }, [filling]);

  const viewBox = `0 0 ${size} ${size}`;
  const radius = (size - STROKE_WIDTH) / 2;
  const halfSize = size / 2;
  const circumference = radius * Math.PI * 2;
  const dash = (progress * circumference) / 100;

  return (
    <CoreBox data-testid="progressCircle" sx={{ width: `${size}px`, height: `${size}px` }}>
      <svg width={size} height={size} viewBox={viewBox}>
        <circle
          fill="none"
          stroke="#ccc"
          cx={halfSize}
          cy={halfSize}
          r={radius}
          strokeWidth={`${STROKE_WIDTH / 2}px`}
        />

        <circle
          fill="none"
          stroke={color}
          cx={halfSize}
          cy={halfSize}
          r={radius}
          strokeWidth={`${STROKE_WIDTH}px`}
          transform={`rotate(-90 ${halfSize} ${halfSize})`}
          strokeDasharray={[dash, circumference - dash] as unknown as number}
          strokeLinecap="round"
          style={STYLES}
        />

        <text fill="#212121" fontSize="16px" x="50%" y="25%" dy="20px" textAnchor="middle">
          {label || `${filling}%`}
        </text>
      </svg>
    </CoreBox>
  );
};
